module.exports = __webpack_public_path__ + "static/media/Blender_logo.eaa2eb9f.svg";